import moment from "moment";

export const dateFormatter = (date: string): string => {
  if (date) {
    // Convert the date string to UTC time
    const utcDate = moment.utc(date);

    // Convert the UTC time to local time and format it
    const formattedDate = utcDate.local().format(" DD MMM YYYY");

    // Return the formatted date string
    return formattedDate;
  }
  return "";
};

export const dateFormatterWithNoYear = (date: string): string => {
  if (date) {
    // Convert the date string to UTC time
    const utcDate = moment.utc(date);

    // Convert the UTC time to local time and format it
    const formattedDate = utcDate.local().format(" DD MMM");

    // Return the formatted date string
    return formattedDate;
  }
  return "";
};

export const dateFormatter2 = (val: string) => {
  // Create a moment object representing the given date and time
  const dateTime = moment(val, "ddd MMM DD YYYY HH:mm:ss ZZ");

  // Convert the moment object to the desired format
  const formattedDate = dateTime.format("YYYY-MM-DD");

  return formattedDate;
};

export const dateTime = (val: string) => {
  // Create a moment object representing the given date and time
  const dateTime = moment(val, "YYYY-MM-DD HH:mm");

  // Format the moment object to only show the time
  const formattedTime = dateTime.format("HH:mm");

  return formattedTime;
};

export const dateFormatter3 = (date: string): string => {
  if (date) {
    // Convert the date string to UTC time
    const utcDate = moment.utc(date);

    // Convert the UTC time to local time and format it
    const formattedDate = utcDate.local().format("YYYY-MM-DD");

    // Return the formatted date string
    return formattedDate;
  }
  return "";
};

const formatter = new Intl.NumberFormat();

export const numberFormatter = (num: number | string) => {
  // Use the formatter to format the number as a string
  return formatter.format(Number(num));
};

export function convertMinutesToHoursAndMinutes(totalMinutes: number) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}

export const isValidEmail = (email: string) => {
  // Define the regex pattern for a valid email
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (email) {
    return pattern.test(email);
  }
  return false;
  // Test the email against the pattern
};

export const replaceSpecialChars = (inputString: string) => {
  // Using regular expression to replace all occurrences of _, -, and / with space
  if (inputString) {
    return inputString.replace(/[_\-/]|fullTime/g, " ");
  }

  return inputString;
};
